<rask-fieldset-toggle
    [formGroup]="$any(control)"
    label="Grotskotning avslutad"
    class="minmaxPanel"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <div class="w-100">
        <rask-datepicker
            label="Grotskotning avslutad"
            formControlName="min"
            class="minmax"></rask-datepicker>
        <span class="splitter">-</span>
        <rask-datepicker
            formControlName="max"
            class="minmax right-minmax"></rask-datepicker>
    </div>
</rask-fieldset-toggle>